import React, { useState } from 'react'

import ContactUs from '../../../assets/ContactUsImage.png'
import Header from '../../../components/Header'
import Input from '../../../components/Input'
import Textarea from '../../../components/Textarea'
import { useAuth } from '../../../contexts/AuthContext'
import { useToast } from '../../../hooks/useToast'
import api from '../../../services/api.js'
import {
  Button,
  Container,
  Content,
  Form,
  Image,
  Title
} from './styles.js'

const ContactWeb = () => {
  const { user } = useAuth()
  const [name, setName] = useState(user?.username)
  const [email, setEmail] = useState(user?.email)
  const [description, setDescription] = useState('')
  const { addToast } = useToast()

  const handleSubmit = () => {
    api
      .post('/contacts', {
        name: name,
        email: email,
        description: description
      })
      .then((res) => {
        if (res.status === 200) {
          setDescription('')
          addToast({
            type: 'sucess',
            title: 'Mensagem enviada',
            description: 'Sua mensagem foi enviada com sucesso'
          })
        } else {
          addToast({
            type: 'error',
            title: 'Mensagem não enviada',
            description: 'Falha em enviar sua mensagem'
          })
        }
      })
  }
  return (
    <>
      <Header Line={false} />
      <Container>
        <Content>
          <Image src={ContactUs} />
          <Form onSubmit={handleSubmit}>
            <Title>Fale Conosco</Title>
            <Input
              responsive
              label="Usuário/MurEr"
              onChange={(e) => setName(e.target.value)}
              type="text"
              id="Nome"
              value={name}
            />
            <Input
              responsive
              label="Email"
              onChange={(e) => setEmail(e.target.value)}
              type="text"
              id="Email"
              value={email}
            />
            <Textarea
              label="Mensagem"
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              type="text"
              id="Mensagem"
            />
            <Button onClick={handleSubmit}>Enviar</Button>
          </Form>
        </Content>
      </Container>
    </>
  )
}

export default ContactWeb
